import { Component, Vue } from "vue-property-decorator";
import Template from "./PermissionManagement.template.vue";

@Component({
  mixins: [Template]
})
export default class PermissionManagementComponent extends Vue {}
